<template>
    <div class="wrapper section_wrapper" :class="current_page['name'].replaceAll('-','_')+'_section_wrapper'">
        <div class="container">
            <div class="section_title"><h1>{{ current_page['display_name'] }}</h1></div>
            <div class="section_content" v-html="current_page['content']"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Default',
        mounted() {
            $('.expand_parent .expand_trigger').on('click', function () {
                let expand_parent = $(this).closest('.expand_parent');
                let expand_wrapper = expand_parent.children('.expand_wrapper');
                if (expand_parent.hasClass('expand_parent_expanded')) {
                    expand_wrapper.animate({
                        height: 0
                    },500,function () {
                        expand_parent.removeClass('expand_parent_expanded')
                    });
                } else {
                    expand_wrapper.animate({
                        height: expand_wrapper.children('.expand_container').outerHeight()
                    },500,function () {
                        expand_parent.addClass('expand_parent_expanded')
                    });
                }
            });
        },
        data() {
            let current_object = this;
            let root = current_object.$root;
            let data_set = {
                current_page: {}
            };
            if (root.current_id.page && root.item_map && root.item_map.page && root.item_map.page[root.current_id.page]) {
                data_set.current_page = root.item_map.page[root.current_id.page];
            }
            return data_set;
        }
    }
</script>